import React from 'react';

type OwnProps = {};
type GMDSSEquipmentSummaryProps = OwnProps;
function GMDSSEquipmentSummary(props: GMDSSEquipmentSummaryProps) {
    return (
        <>
            <div className="flex flex-col justify-between py-4 px-8 mb-2 print-page-break">
                <div className="font-medium text-center text-xl my-2 mx-0">
                    <h2 className="uppercase text-2xl">
                        GMDSS LOGBOOK: SAMPLE ENTRIES
                    </h2>
                </div>

                <div className="flex justify-center mt-8 mb-2">
                    <div className="w-full max-w-4xl print:max-w-none">
                        <div className="overflow-x-auto">
                            <table className="w-full text-left border-collapse">
                                <thead>
                                    <tr className="bg-yellow-500">
                                        <th className="p-0.5 text-sm font-medium border-2 border-yellow-500 border-b pl-8">
                                            COMMUNICATION EQUIPMENT
                                        </th>
                                        <th className="p-0.5 text-sm font-medium border-2 border-yellow-500 border-b">
                                            DAILY
                                        </th>
                                        <th className="p-0.5 text-sm font-medium border-2 border-yellow-500 border-b">
                                            WEEKLY
                                        </th>
                                        <th className="p-0.5 text-sm font-medium border-2 border-yellow-500 border-b">
                                            MONTHLY
                                        </th>
                                        <th className="p-0.5 text-sm font-medium border-2 border-yellow-500 border-b">
                                            ANNUAL
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="hover:bg-gray-50 bg-yellow-200">
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b pl-4">
                                            VHF DSC (radiation)
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center">
                                            ✓
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                    </tr>
                                    <tr className="hover:bg-gray-50">
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b pl-4">
                                            VHF R/T for operational use
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center">
                                            ✓
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 bg-yellow-200">
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b pl-4">
                                            MF/HF DSC test (without radiation)
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center">
                                            ✓
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                    </tr>
                                    <tr className="hover:bg-gray-50">
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b pl-4">
                                            MF/HF live DSC test call with coast
                                            station
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center">
                                            ✓
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 bg-yellow-200">
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b pl-4">
                                            Printers for all GMDSS Equipment
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center">
                                            ✓
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                    </tr>
                                    <tr className="hover:bg-gray-50">
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b pl-4">
                                            NAVTEX self-test *
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center">
                                            ✓
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 bg-yellow-200">
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b pl-4">
                                            INMARSAT tested for operational use
                                            (satellite selection, reception of
                                            Safety messages etc.)
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center">
                                            ✓
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                    </tr>
                                    <tr className="hover:bg-gray-50">
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b pl-4">
                                            INMARSAT Communication & P/V test
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center">
                                            ✓
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 bg-yellow-200">
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b pl-4">
                                            NBDP (Narrow Band Direct Printing) —
                                            Test with coast station
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center">
                                            ✓
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                    </tr>
                                    <tr className="hover:bg-gray-50">
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b pl-4">
                                            Two-way survival craft VHF (other
                                            than Ch 16) & seal on primary
                                            battery (non-rechargeable)
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center">
                                            ✓
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 bg-yellow-200">
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b pl-4">
                                            EPIRB physical examination and self
                                            test *
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center">
                                            ✓
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                    </tr>

                                    <tr className="hover:bg-gray-50">
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b pl-4">
                                            SART physical examination and
                                            self-test *
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center">
                                            ✓
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 bg-yellow-200">
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b pl-4">
                                            GMDSS Battery: Physical condition,
                                            securing & safety. Terminals
                                            protected from moisture and humidity
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center">
                                            ✓
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                    </tr>
                                    <tr className="hover:bg-gray-50">
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b pl-4">
                                            GMDSS Battery On/Off load
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center">
                                            ✓
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 bg-yellow-200">
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b pl-4">
                                            GMDSS Battery Capacity Test
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center">
                                            ✓
                                        </td>
                                    </tr>

                                    <tr className="hover:bg-gray-50">
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b pl-4">
                                            Power: Non-Battery (e.g., Generator)
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center">
                                            ✓
                                        </td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                        <td className="p-0.5 text-sm border-2 border-yellow-500 border-b text-center"></td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 bg-yellow-200 border-yellow-500 border">
                                        <td
                                            colSpan={5}
                                            className="p-0.5 text-sm border-2 border-yellow-500 border-b pl-4 italic text-blue-700"
                                        >
                                            * Refer Maker's instructions for
                                            Self-test
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default GMDSSEquipmentSummary;
